import React, {Component} from 'react';
import axios from 'axios';
import ModalComponent from  '../../../components/ModalComponent';
import {FaDatabase, FaSearch} from "react-icons/fa";
import {
    Button,
    Card,
    CardBody, Input, InputGroup, InputGroupAddon,
    Table
} from 'reactstrap';
import { connect } from 'react-redux';
import { Alert } from 'reactstrap';
import { Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PaginateComponent from "../../../components/PaginateComponent";
import BreadcrumbCustomer from "../../../components/Layout/user/BreadcrumbCustomer";
import ListHostingCancelComponent from "../../../components/Customer/hostings/ListHostingCancelComponent";
import ListButtonComponent from "../../../components/Customer/hostings/ListButtonComponent"

class ListHostingCancelPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loadPage: true,
            isLoading: true,
            listService: [],
            perPage: 0,
            totalPage: 0,
            currentPage: 0,
            error: false,
            messageError: '',
            isNotification: '',
            textNotification: '',
            isModal: false,
            titleModal: '',
            modalBody: '',
            action: '',
            isBtnConfirm: true,
            contentModal: '',
            btnConfirmDisabled: false,
            isSpinner: false,
            actionKey: 0,
            alert: {
                error: false,
                message: ''
            },
            qtt: 30,
            q: '',
            checkAll: false,
            os: 0
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.getListHosting();

        this.setState({
            isNotification: this.props.isNotification,
            textNotification: this.props.textNotification,
        })
        if ( this.props.isNotification ) {
            this.props.notification({
                isNotification: false,
                textNotification: ''
            });
        }
    }

    getListHosting = () => {
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        let data = "?qtt=" + this.state.qtt + "&q=" + this.state.q + "&type=cancel";

        axios.get( process.env.REACT_APP_API_URL + '/api/hosting/getListHosting' + data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                if ( ref.data.error === 0 ) {
                    this.setState({
                        listService: ref.data.content.data,
                        perPage: ref.data.content.perPage,
                        totalPage: ref.data.content.total,
                        currentPage: ref.data.content.current_page,
                        loadPage: false,
                        isLoading: false,
                    })
                } else {
                    if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                            loadPage: false,
                            isLoading: false,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    loadPage: false,
                    isLoading: false,
                    error: true,
                    messageError: 'Lấy dữ liệu Hosting thất bại',
                })
            })
    }

    changeQtt = async (event) => {
        let value = event.target.value;
        await this.setState({
            qtt: value
        })
        await this.getListHosting();
    }

    search = (event) => {
        // console.log(event.target.value)
        this.setState({
            q: event.target.value
        })
    }

    submitSearch = (event) => {
        if(event.key === 'Enter') {
            this.getListHosting();
        }
    }

    btnSearch = () => {
        this.getListVps();
    }

    paginate = () => {
        if (this.state.totalPage > this.state.perPage) {
            return (
                <PaginateComponent
                    total={this.state.totalPage}
                    perPage={this.state.perPage}
                    currentPage={this.state.currentPage}
                    btnPaginate={ (page) => this.btnPaginate(page) }
                />
            );
        }
    }

    btnPaginate = (page) => {
        this.setState({
            isLoading: true
        });
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        // console.log(dataAuth);
        let data = "?qtt=" + this.state.qtt + "&q=" + this.state.q + "&type=cancel&page=" + page;
        axios.get( process.env.REACT_APP_API_URL + '/api/hosting/getListHosting' + data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                if ( ref.data.error === 0 ) {
                    this.setState({
                        listService: ref.data.content.data,
                        perPage: ref.data.content.perPage,
                        totalPage: ref.data.content.total,
                        currentPage: ref.data.content.current_page,
                        loadPage: false,
                        isLoading: false,
                    })
                } else {
                    if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                            loadPage: false,
                            isLoading: false,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    loadPage: false,
                    isLoading: false,
                    error: true,
                    messageError: 'Lấy dữ liệu Hosting thất bại',
                })
            })
    }

    screentListService = () => {
        if ( this.state.isLoading ) {
            return (
                <tr>
                    <td className="text-center" colSpan={12}>
                        <Spinner animation="grow" variant="primary" />
                        <Spinner animation="grow" variant="secondary" />
                        <Spinner animation="grow" variant="success" />
                        <Spinner animation="grow" variant="danger" />
                        <Spinner animation="grow" variant="warning" />
                        <Spinner animation="grow" variant="info" />
                    </td>
                </tr>
            );
        } else {
            if ( this.state.listService.length ) {
                return (
                    this.state.listService.map( (service, key) => {
                        return (
                            <ListHostingCancelComponent
                                key={key}
                                service={service}
                                actionKey={key}
                                showModal = { (actionKey, action) => this.showModal(actionKey, action) }
                                checkedService = { (actionKey) => this.checkedService(actionKey) }
                            />
                        )
                    })
                )
            } else {
                return (
                    <tr>
                        <td className="text-center text-danger" colSpan="12">
                            Không có Hosting trong dữ liệu!
                        </td>
                    </tr>
                )
            }
        }
    }

    checkedService  = (actionKey) => {
        let listService = this.state.listService;
        listService[actionKey].checked = true;
        this.setState({
            listService: listService
        })
    }

    checkAll = (event) => {
        let value = event.target.checked;
        let listService = this.state.listService;
        listService.forEach( service => {
            service.checked = value;
        })
        this.setState({
            checkAll: value,
            listService: this.state.listService
        })
    }

    showModal = (key, action) => {
        let titleModal;
        let modalBody;
        if ( action === 'delete' ) {
            titleModal = 'Hủy Hosting';
            modalBody = this.modalBody(key, action);
        }
        else if ( action === 'expire' ) {
            titleModal = 'Yêu cầu gia hạn Hosting';
            modalBody = this.modalBody(key, action);
        }
        this.setState({
            action: action,
            isModal: true,
            btnConfirmDisabled: false,
            contentModal: {
                modalBody: modalBody,
                title: titleModal
            },
            isBtnConfirm: true,
            isSpinner: false,
            actionKey: key
        })
    }

    modalBody = (key, action) => {
        if ( action === 'delete' ) {
            return (
                <div className="text-center">
                    Bạn có muốn hủy dịch vụ Hosting <b className="text-danger">({ this.state.listService[key].domain })</b> này không?
                </div>
            )
        }
        else if ( action === 'expire' ) {
            return (
                <div className="text-center">
                    Bạn có muốn gia hạn dịch vụ Hosting <b className="text-danger">({ this.state.listService[key].domain })</b> này không?
                </div>
            )
        }
        else if ( action === 'finish_expire' ) {
            return (
                <div className="text-center">
                    Yêu cầu gia hạn Hosting thành công. Quý khách vui lòng bấm <a href="/" onClick={ () => this.redirectDetailOrder() }>vào đây </a>
                    để thanh toán hoàn thành quá trình gia hạn.
                </div>
            )
        }
        else if ( action === 'confirm_expire' ) {
            return (
                <div className="text-center">
                    <label htmlFor="choose_vps">Chọn thời gian gia hạn</label>
                    <select className="form-control text-center" name="billingCycle" id="billingCycle" onChange={this.changeInput} defaultValue={key[0].id}>
                        {
                            key.map( (billingCycle, keyBc) => (
                                <option value={ billingCycle.id } key={keyBc}>{ billingCycle.value }</option>
                            ))
                        }
                    </select>
                </div>
            )
        }
    }

    redirectDetailOrder = () => {
        let link = "/don-dat-hang/" + this.state.orderId + "/chi-tiet-don-dat-hang.html";
        this.hiddenModal();
        window.open(link, '_blank');
    }


    hiddenModal = () => {
        this.setState({
            action: '',
            isModal: false,
        })
    }

    confirmModal = () => {
        if ( this.state.action === 'finish_expire' ) {
            let link = "/don-dat-hang/" + this.state.orderId + "/chi-tiet-don-dat-hang.html";
            window.open(link, '_blank');
            this.hiddenModal();
        }
        else {
            this.setState({
                btnConfirmDisabled: true,
                isSpinner: true,
                isBtnConfirm: false,
                alert: {
                    error: false,
                    message: ''
                }
            })
            let dataAuth = {
                username: process.env.REACT_APP_CLIENT_ID,
                password: process.env.REACT_APP_CLIENT_PASSWD,
                token: process.env.REACT_APP_KEY,
            };
            let form = {
                hostingId: this.state.listService[ this.state.actionKey ].id,
                action: this.state.action,
                billingCycle: this.state.billingCycle,
                os: this.state.os

            };

            axios.put( process.env.REACT_APP_API_URL + '/api/hosting/action', form,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization' : this.props.token,
                        'dataAgency' : JSON.stringify(dataAuth)
                    }
                }
            )
                .then( (ref) => {
                    // console.log(ref.data);
                    this.setState({
                        isSpinner: false,
                    });
                    if ( ref.data.error > 9000 ) {
                        this.props.logOut();
                    }
                    else if ( ref.data.error ) {
                        this.setState({
                            contentModal: {
                                modalBody: this.modalBodyConfirm(ref.data.error,ref.data.message),
                                title: this.state.contentModal.title
                            },
                        })
                    }
                    else {
                        if ( this.state.action === 'expire' ) {
                            let titleModal = 'Yêu cầu gia hạn Hosting';
                            let modalBody = this.modalBody( ref.data.content , 'confirm_expire');
                            this.setState({
                                btnConfirmDisabled: false,
                                contentModal: {
                                    modalBody: modalBody,
                                    title: titleModal
                                },
                                billingCycle: ref.data.content[0].id,
                                isBtnConfirm: true,
                                isSpinner: false,
                                action: 'confirm_expire',
                                orderId: 0
                            })
                        }
                        else if ( this.state.action === 'confirm_expire' ) {
                            let titleModal = 'Yêu cầu gia hạn Hosting';
                            let modalBody = this.modalBody( ref.data.content , 'finish_expire');
                            this.setState({
                                btnConfirmDisabled: false,
                                contentModal: {
                                    modalBody: modalBody,
                                    title: titleModal
                                },
                                isBtnConfirm: true,
                                btnPayment: true,
                                isSpinner: false,
                                action: 'finish_expire',
                                orderId: ref.data.content
                            })
                        }
                        else {
                            if ( !ref.data.error ) {
                                window.scrollTo(0, 0);
                                this.getListHosting();
                            }
                            this.setState({
                                contentModal: {
                                    modalBody: this.modalBodyConfirm(ref.data.error,ref.data.message),
                                    title: this.state.contentModal.title
                                },
                            })
                        }
                    }
                    // console.log(this.state.perPage);
                })
                .catch( (error) => {
                    console.log(error);
                    this.setState({
                        isSpinner: false,
                        contentModal: {
                            title: this.state.contentModal.title,
                            modalBody: this.modalBodyConfirm(1, 'Thực hiện hành động không thành công')
                        },
                    })
                })
        }
    }

    checkNotification = () => {
        if ( this.state.isNotification ) {
            return (
                <Alert color="success">
                    { this.state.textNotification }
                </Alert>
            );
        }
    }

    modalBodyConfirm = (error, message) => {
        if ( error ) {
            return (
                <div className="text-center text-danger">
                    { message }
                </div>
            )
        } else {
            return (
                <div className="text-center text-success">
                    { message }
                </div>
            )
        }
    }

    listBtn = () => {
        return (
            <>
                <Link
                    className={ "btn btn-success m-1" }
                    to={ '/dich-vu-hosting/dang-su-dung.html' }
                >
                    Đang sử dụng
                </Link>
                <Link
                    className={ "btn btn-primary m-1" }
                    to={ '/dich-vu-hosting/con-han.html' }
                >
                    Còn hạn
                </Link>
                <Link
                    className={ "btn btn-info m-1" }
                    to={ '/dich-vu-hosting/da-het-han.html' }
                >
                    Đã hết hạn
                </Link>
                <button
                    className={ "btn btn-warning m-1 text-light" }
                    disabled={true}
                >
                    Hủy - xóa - Chuyển
                </button>
                <Link
                    className={ "btn btn-danger m-1" }
                    to={ '/dich-vu-hosting/tat-ca-dich-vu-vps.html' }
                >
                    Tất cả dịch vụ
                </Link>
            </>
        )
    }

    changeInput = (event) => {
        let name = event.target.name;
        let value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        this.setState({
            [name]: value
        });
    }

    render() {
        return (
            <>
                {
                    this.state.loadPage ? (
                        <div className="cr-page-spinner load-page">
                            <Spinner animation="border" variant="primary" />
                        </div>
                    ) : (
                        <>
                            <BreadcrumbCustomer title={"Dịch vụ Hosting hủy/xóa/chuyển"} page={"Hosting"} icon={<FaDatabase className="breadcrumb-icon"/>} />
                            <div className="list-button">
                                {/* { this.listBtn() } */}
                                <ListButtonComponent active="cancel" />
                            </div>
                            <hr/>
                            <Card>
                                <CardBody>
                                    <div className="row">
                                        <div className="col-md-5 mb-3">
                                            <select className="form-control form-control-sm m-1" value={this.state.qtt} onChange={ this.changeQtt }>
                                                <option value="10">10</option>
                                                <option value="20">20</option>
                                                <option value="30">30</option>
                                                <option value="50">50</option>
                                                <option value="100">100</option>
                                                <option value="200">200</option>
                                            </select>
                                        </div>
                                        <div className="col-md-7">
                                            <InputGroup className="input-group-sm m-1">
                                                <Input placeholder="Tìm kiếm Hosting" onChange={ this.search } onKeyPress={ this.submitSearch } />
                                                <InputGroupAddon addonType="prepend">
                                                    <Button onClick={ () => this.btnSearch() }> <FaSearch /> </Button>
                                                </InputGroupAddon>
                                            </InputGroup>
                                        </div>
                                        <div className="col-md-12">
                                            {
                                                this.checkNotification()
                                            }
                                        </div>
                                        <div className="col col-md-12 table-responsive mt-3">
                                            <Table className="table table-sm table-bordered table-hover rounded text-center table-service">
                                                <thead>
                                                <tr>
                                                    <th>Domain</th>
                                                    <th>Sản phẩm</th>
                                                    <th>Ngày tạo</th>
                                                    <th>Ngày kết thúc</th>
                                                    <th>Tổng thời gian thuê</th>
                                                    <th>Chu kỳ thanh toán</th>
                                                    <th>Chi phí</th>
                                                    <th>Trạng thái</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                { this.screentListService() }
                                                </tbody>
                                            </Table>

                                            <div className="row">
                                                <div className="col-12 mb-0">
                                                    <div className="d-md-flex float-md-right pagination-sm">
                                                         <table>
                                                             <tbody>
                                                                 { this.paginate() }
                                                             </tbody>
                                                          </table>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                            <ModalComponent
                                isModal={ this.state.isModal }
                                content={this.state.contentModal}
                                isBtnConfirm={ this.state.isBtnConfirm }
                                isSpinner={ this.state.isSpinner }
                                btnConfirmDisabled={ this.state.btnConfirmDisabled }
                                hiddenModal={ () => this.hiddenModal() }
                                confirmModal={ () => this.confirmModal() }
                                alert={ this.state.alert }
                            />
                        </>
                    )
                }
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.login.token,
        isNotification: state.adminMain.isNotification,
        textNotification: state.adminMain.textNotification,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        logOut: () => {
            dispatch(({ type : 'logOut', page: 'CustomerHostingCancel' }))
        },
        notification: (item) => {
            dispatch(({ type : 'notification', item }))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ListHostingCancelPage);